import React, { useState, useEffect } from "react";

export const SearchField = (props) => {
    const [filter, setFilter] = useState('');
    const [typingTimeout, setTimer] = useState(0);
    
    const handleFilterChange = (e) => {
        const {value} = e.target;
        setFilter(e.target.value)
        if(value) {
            if(typingTimeout) {
                clearTimeout(typingTimeout);
            }
        }

        setTimer(setTimeout(() => {

        }, 500))
        console.log("🚀 ~ file: SearchField.jsx ~ line 5 ~ SearchField ~ filter", filter)


    }

    return (
        <div className="searchBox">
            <input
                type="text"
                placeholder="Search Tag by Code, Title or Description"
                className="form-control"
                value={filter}
                onChange={handleFilterChange}
            />
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/Admin/HelperComponents/SearchField.jsx